<template>
  <form class="checkout-step-1" @submit.prevent="submit">
    <div class="form-row">
      <div class="col-lg-8">
        <form-group
          id="name"
          v-model="form.name"
          :errors="errors.name"
          placeholder="Digite o seu nome completo"
          label="Nome completo*"
        />
      </div>
      <div class="col-lg-4">
        <form-group
          id="type"
          select
          :options="typeOptions"
          v-model="form.type"
          :errors="errors.type"
          label="Tipo de pessoa*"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="col-lg-6">
        <form-group
          id="document"
          type="tel"
          v-model="form.document"
          :errors="errors.document"
          placeholder="Digite o número do seu CPF"
          label="Número do CPF*"
        />
      </div>
      <div class="col-lg-6">
        <form-group
          id="email"
          type="email"
          v-model="form.email"
          :errors="errors.email"
          placeholder="Digite o seu e-mail"
          label="Endereço de e-mail*"
        />
      </div>
    </div>
    <div class="form-row mb-4">
      <div class="col-lg-6">
        <form-group
          id="phone"
          type="tel"
          v-model="form.phone"
          :errors="errors.phone"
          placeholder="Digite o seu número de telefone"
          label="Telefone*"
        />
      </div>
      <div class="col-lg-6">
        <form-group
          id="mobile_phone"
          type="tel"
          v-model="form.mobile_phone"
          :errors="errors.mobile_phone"
          placeholder="Digite o número do seu celular"
          label="Celular (opcional)"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="col-lg-6">
        <form-group
          id="address"
          v-model="form.address"
          :errors="errors.address"
          placeholder="Digite o seu endereço"
          label="Endereço completo*"
        />
      </div>
      <div class="col-lg-2">
        <form-group
          id="number"
          type="tel"
          v-model="form.number"
          :errors="errors.number"
          placeholder="0000"
          label="Número*"
        />
      </div>
      <div class="col-lg-4">
        <form-group
          id="cep"
          type="tel"
          v-model="form.cep"
          :errors="errors.cep"
          placeholder="Digite o CEP"
          label="CEP*"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="col-lg-6">
        <form-group
          id="complement"
          v-model="form.complement"
          :errors="errors.complement"
          placeholder="Ex: Apartamento 1"
          label="Complemento (opcional)"
        />
      </div>
      <div class="col-lg-6">
        <form-group
          id="city"
          v-model="form.city"
          :errors="errors.city"
          placeholder="Digite sua cidade"
          label="Cidade*"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="col-lg-4">
        <form-group
          id="district"
          v-model="form.district"
          :errors="errors.district"
          placeholder="Digite seu bairro"
          label="Bairro (opcional)"
        />
      </div>
      <div class="col-lg-4">
        <form-group
          id="state"
          v-model="form.state"
          :errors="errors.state"
          placeholder="Digite seu estado"
          label="Estado*"
        />
      </div>
      <div class="col-lg-4">
        <form-group
          id="country"
          v-model="form.country"
          :errors="errors.country"
          placeholder="Digite seu país"
          label="País*"
        />
      </div>
    </div>
    <div class="text-right">
      <button class="btn btn-success px-5 font-weight-bold">
        Próximo passo
      </button>
    </div>
  </form>
</template>

<script>
import { formFields } from "@/functions/helpers.js";

export default {
  data() {
    return {
      loading: false,
      ...formFields(
        [
          "name",
          "type",
          "document",
          "email",
          "phone",
          "mobile_phone",
          "address",
          "number",
          "cep",
          "complement",
          "city",
          "district",
          "state",
          "country"
        ],
        { type: "cpf" }
      ),
      typeOptions: [
        { id: "cpf", name: "Pessoa física" },
        { id: "cnpj", name: "Pessoa jurídica" }
      ]
    };
  },
  methods: {
    submit() {
      this.$emit("success", this.form);
    }
  }
};
</script>
